import { ConfigProvider } from 'antd';
import ptBR from 'antd/locale/pt_BR';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { AuthProvider } from './lib/auth';
import { temaAntd } from './styles/customTokens';
import './styles/kit.css';
import './styles/app.css';

const raiz = document.getElementById('root');
if (!raiz) throw new Error('elemento #root não encontrado');

createRoot(raiz).render(
  <StrictMode>
    {/* Os tokens do Ant Design vêm do mesmo mapa que alimenta o CSS: um lugar
        só para mudar cor, raio e tipografia. */}
    <ConfigProvider locale={ptBR} theme={temaAntd()}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ConfigProvider>
  </StrictMode>,
);
